export const addSmblsSubdomains = async function addSmblsSubdomains(appKey) {
  const res1 = await this.call('addSmblsSubdomain', appKey)
  const res2 = await this.call('addSmblsSubdomain', `www.${appKey}`)

  const successMsg = 'Domain registered successfully'
  if (res1.message.startsWith(successMsg) && res2.message.startsWith(successMsg)) {
    this.call('openNotification', {
      title: successMsg,
      message: this.call('polyglot', 'editor.subdomain.registered').replace('{key}', appKey),
      type: 'success'
    })
  } else {
    this.call('openNotification', {
      title: this.call('polyglot', 'editor.subdomain.error'),
      message: res1.message + '\n' + res2.message,
      type: 'error'
    })
  }
}
